<template>
  <div class="quad-viz-pure">
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex><strong>公式：</strong>△ABC ∽ △A'B'C'</div>
    </div>

    <div class="main-layout vertical">
      <div class="canvas-box simulation">
        <svg width="100%" height="280" viewBox="0 0 500 280">
          <g transform="translate(100, 180)">
             <!-- Triangle 1 -->
             <polygon :points="p1" fill="rgba(46, 213, 115, 0.1)" stroke="#2ed573" stroke-width="2" />
             <text :x="avgX1" :y="avgY1" fill="#2ed573" font-size="12" text-anchor="middle">S₁</text>
             
             <!-- Triangle 2 -->
             <g :transform="`translate(${150 + (1-k)*50}, 0)`">
                <polygon :points="p2" fill="rgba(0, 210, 255, 0.1)" stroke="#00d2ff" stroke-width="2" />
                <text :x="avgX2" :y="avgY2" fill="#00d2ff" font-size="12" text-anchor="middle">S₂</text>
             </g>

             <!-- Correspondence lines (Optional guide) -->
             <line :x1="0" :y1="-80" :x2="250" :y2="-80*k" stroke="rgba(255,255,255,0.05)" stroke-dasharray="4" />
          </g>
        </svg>
      </div>

      <div class="bottom-controls">
        <div class="discovery-note" v-latex>
          <p><strong>相似性质：</strong>当两个三角形对应角相等、对应边成比例时，它们互为相似三角形。其**周长之比等于相似比k**，而**面积之比等于相似比的平方 k²**。这是解决几何比例问题的核心工具。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SimilarTrianglesViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      k: 1.2
    }
  },
  computed: {
    p1() { return "0,-80 80,0 -20,0"; },
    p2() { 
      const k = this.k;
      return `0,${-80*k} ${80*k},0 ${-20*k},0`;
    },
    avgX1() { return (0+80-20)/3; },
    avgY1() { return -40/3; },
    avgX2() { return (0+80*this.k-20*this.k)/3; },
    avgY2() { return (-80*this.k)/3; }
  }
}
</script>

<style scoped lang="scss">
.similar-triangles-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.canvas-box { background: #010205; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05); }
.bottom-controls { flex: 0.6; display: flex; flex-direction: column; gap: 10px; }
.control-card { background: rgba(255,255,255,0.02); border-radius: 12px; padding: 15px; }
.discovery-note { background: rgba(46, 213, 115, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>